import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { PendingAgreement } from './api/agreements.api';
import { BehaviorSubject, of } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AgreementAcceptanceService {
  private pending$ = new BehaviorSubject<PendingAgreement[] | undefined>(
    undefined
  );
  invalidatePending() {
    this.pending$.next(undefined);
  }
  getPendingValue() {
    return this.pending$.value;
  }
  getPendingObs() {
    return this.pending$.asObservable().pipe(
      switchMap((pending) => {
        if (pending) return of(pending);
        return this.apiService.agreements.getPending();
      }),
      tap((pending) => {
        if (this.pending$.value !== pending) this.pending$.next(pending);
      })
    );
  }

  constructor(private apiService: ApiService) {
    //
  }
}
